import { Quote } from 'components/flair/Quote';
import React from 'react';

export const HeroSection: React.FC = () => (
  <div className='py-4 md:py-6'>
    <div className='mb-8 flex flex-col gap-3 md:mb-12 md:gap-4'>
      <div className='text-red-950 leading-trim-both text-edge-cap justify-center self-stretch text-2xl font-bold leading-[120%] sm:text-2xl md:text-3xl'>
        Where Shef Cooks & Delivers Homemade Food!
      </div>
      <div className='text-red-950 justify-start text-sm font-normal leading-relaxed sm:text-base md:text-lg'>
        Shef is a chef-to-consumer marketplace that connects talented local cooks with customers looking for healthy,
        homemade meals.
        <br className='hidden sm:block' />
        Shef is a great alternative to fast food or takeout, as it provides a healthier, more personalized food delivery
        experience. Plus, with
        <br className='hidden sm:block' />
        the ability to filter by dietary preferences and ingredients, Shef makes it easy for customers to find dishes
        that fit their specific
        <br className='hidden sm:block' />
        needs and preferences. Whether you're looking for a quick lunchtime meal or a hearty dinner for the whole
        family, Shef has
        <br className='hidden sm:block' />
        something for everyone.
      </div>
    </div>
    <Quote
      text={
        'Food for us comes from our relatives, whether they have wings or fins or roots. That is how we consider food. Food has a culture. It has a history. It has a story. It has relationships.'
      }
      author='- Winona LaDuke'
      avatarSrc='/images/CDN/winona_laduke.png'
      variant='subtle'
    />
  </div>
);
